<template>
  <div class="home">
    <div class="Home">
      <div class="home-left">
        <div class="text">
          <div class="PlamCube">PalmCube</div>
          <p>Manage your hotel as easy as using mobile phone Unlock Your Hotel's Earning Potential</p>
        </div>
      </div>

      <div class="home-right">
        <div class="img">
          <img src="../assets/diannao1.png" alt="">
        </div>
      </div>
    </div>
    <div class="HomePhone">
      <Float></Float>
      <div class="HomePhone-s">
        <img src="../assets/diannao1.png" alt="">

      </div>

      <div class="HomePhone-x">

        <span>PalmCube</span>
        <p>Manage your hotel as easy as using mobile phone <br> Unlock Your Hotel's Earning Potential</p>

      </div>

      <div class="centerPhone">
        <div class="centerPhone-t">
          <span>BLUEPRINT</span>
          <p>improve guest satisfaction</p>
          <p> improved revenue</p>
          <p>Digitalized operation</p>
        </div>

        <div class="centerPhone-x">
          <img src="../assets/phone4.png" alt="">
        </div>

      </div>
      <div class="content-phone">
        <img src="../assets/What we provide.png" alt="">
        <img src="../assets/Palm Cube-Logo-06.png" alt="">
        <div class="content-phoneDig">
          <p>Digital Management <br>
            Operation System & Devices</p>
          <p>Sales Solution</p>
        </div>
        <div class="content-phoneHot">
          <div>
            <img src="../assets/PalmHotel.png" alt="">
            <img src="../assets/Palm Cube-Logo-08.png" alt="">
          </div>
          <div>
            <img class="webImg" src="../assets/web +.png" alt="">

          </div>
          <div>
            <img src="../assets/Palm Cube-Logo-09.png" alt="">

          </div>
        </div>
      </div>
      <div class="footPhone">

        <img src="../assets/phone29.png" alt=""  @click="imageClick1" >
        <img src="../assets/phone30.png" alt="" @click="imageClick2">
        <img src="../assets/phone31.png" alt="" @click="imageClick3">

      </div>
      <div class="footPhoneP">
        <img src="../assets/Palm Cube-Logo-06.png" alt="">
        <p>+234 906 483 7926</p>
        <p>lockettqin@palm-cube.com</p>
      </div>

    </div>
    <div class="center">

      <div class="center-s">
        <div>
          <span>Customized Upsells</span>
          <p>Deliver tailored offers, upgrades, and <br>
            services by leveraging quest data to <br>
            anticipate and cater to individual pref- <br>
            erences and needs.</p>
        </div>
        <div>
          <span>Personalized <br>Trip Management</span>

          <p>Enable quests to effortiessly growss, select, <br>
            and book services, amenities, and attractions <br>
            through a user-friendly web app or guest <br>
            app.</p>
        </div>
        <div>
          <span>Digital Keys</span>
          <p>Integrate keyless entry systems for a hassle- <br>
            free experience, saving time on key creation <br>
            and ensuring swift room access.</p>
        </div>

      </div>
      <div class="center-z">
        <div>
          <span>BLUEPRINT</span>
          <p>Improve guest satisfaction</p>
          <p>Improved revenue</p>
          <p>Digitalized operation</p>
        </div>
      </div>
      <div class="center-x">
        <div>
          <span>Centralized <br>Communication Hub</span>
          <p>Communicate and keep track of the <br>
            full conversation in one place no <br>
            matter where amossage is sent; <br>
            Email, WhatApp, SNS and more</p>
        </div>
        <div>
          <span>Streamlined Online <br>Check-in & <br> Check-out</span>
          <p>Enhanced check in Experience, Offer- <br>
            ing Various Self-service, Online, and <br>
            Expedited Check-in Options.</p>
        </div>
        <div>
          <span>Direct Guest Communication</span>
          <p>Communicate with guests via open <br>
            channels before arrival and <br>
            throughout the entire stay</p>
        </div>

      </div>

    </div>
    <div class="content">
      <div class="content-what">
        <img src="../assets/What we provide.png" alt="">
      </div>
      <div class="content-cube">
        <img src="../assets/Palm Cube-Logo-06.png" alt="">

      </div>
      <!-- <div class="content-phase">
        <span>PHASEI</span>
      </div> -->
      <div class="content-dig">
        <div>
          <p>Digital Management <br>
            Operation System & Devices</p>
        </div>
        <div>
          <p>Sales Solution</p>
        </div>
      </div>
      <div class="content-img">
        <div>
          <img src="../assets/PalmHotel.png" alt="">
          <img src="../assets/Palm Cube-Logo-08.png" alt="">
        </div>
        <div>
          <img class="webImg" src="../assets/web +.png" alt="">

        </div>
        <div>
          <img src="../assets/Palm Cube-Logo-09.png" alt="">

        </div>

      </div>
    </div>

    <div class="foot">
      <div>
        <img src="../assets/web31.png" alt="" @click="imageClick1">
        <img src="../assets/web30.png" alt="" @click="imageClick2">
        <img src="../assets/web29.png" alt="" @click="imageClick3">
      </div>


    </div>
    <div class="weet">
      <div class="weet-l">
        <img src="../assets/Palm Cube-Logo-06.png" alt="">
      </div>
      <div class="weet-r">
        <span>+234 906 483 7926</span>
        <span>lockettqin@palm-cube.com</span>
      </div>
    </div>
  </div>
</template>

<script>
import  Float  from "../components/Float";
export default {
  components:{
    Float
  },
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    imageClick1() {
      this.$router.push('/products');
    },
    imageClick2() {
      this.$router.push('/palmcube');
    },
    imageClick3() {
      this.$router.push('/boomsales');
    }
  },

}
</script>
<style lang="scss">
.Home {
  padding: 20px 40px;
  display: block;
  margin-top: -44px;
  background: url(../assets/background2.png) no-repeat;
  background-size: 100%;
  // width: 100%;
  height: 420px;
  display: flex;

  .home-left {
    width: 40%;
    display: flex;

    .text {
      margin: auto;

      .PlamCube {
        font-size: 16px;
        font-weight: 600;
        color: #363663;
      }

      p {
        font-size: 12px;
        color: #6968a1;

      }
    }


  }

  .home-right {
    width: 60%;
    display: flex;

    .img {
      margin: auto;

      img {
        width: 300px;
        // height: 507px;
      }
    }

  }

}

.HomePhone {
  display: none;
  background: url(../assets/phone1.png) no-repeat;
  height: 1300px;
  background-size: 100%;

  .HomePhone-s {

    // width: 100%;
    img {
      //  text-align: center;
      margin-left: 100px;
      margin-top: 450px;
      width: 500px;
    }
  }

  .HomePhone-x {

    span {
      margin-top: 120px;
      display: block;
      text-align: center;
      color: #363663;
      font-weight: 600;

      // font-size: 12px;
    }

    p {
      text-align: center;
      font-size: 28px;
      color: #6968a1;


    }
  }
}

.center {
  display: block;

  background: url(../assets/center.png) no-repeat center/80%;
  // background-size: 50%;
  margin-top: 20px;
  height: 300px;

  .center-s {
    display: flex;
    justify-content: space-evenly;



    >div:nth-child(1) span {
      margin-top: 20px;
      color: #fff;
      font-size: 10px;
      font-weight: 600;
      display: block;
    }

    >div:nth-child(1) p {
      margin-top: 10px;
      color: #fff;
      font-size: 6px;
    }

    >div:nth-child(2) span {
      margin-top: 20px;
      color: #444198;
      font-size: 10px;
      font-weight: 600;
      display: block;
    }

    >div:nth-child(2) p {
      margin-top: 10px;
      color: #444198;
      font-size: 6px;
    }

    >div:nth-child(3) span {
      margin-top: 20px;
      color: #fff;
      font-size: 10px;
      font-weight: 600;
      display: block;
    }

    >div:nth-child(3) p {
      margin-top: 10px;
      color: #fff;
      font-size: 6px;
    }



  }

  .center-z {
    display: flex;
    margin-top: 10px;

    >div:nth-child(1) {
      margin: auto;
    }

    >div:nth-child(1) span {
      color: #c69c6c;
      font-size: 18px;
      font-weight: 600;
    }

    >div:nth-child(1) p {
      color: #444198;
      font-size: 8px;
      font-weight: 600;
    }
  }

  .center-x {
    display: flex;
    justify-content: space-evenly;

    >div:nth-child(1) span {
      margin-top: 20px;
      color: #444198;
      font-size: 10px;
      font-weight: 600;
      display: block;
    }

    >div:nth-child(1) p {
      color: #444198;
      font-size: 6px;
    }

    >div:nth-child(2) span {
      margin-top: 20px;
      color: #fff;
      font-size: 10px;
      font-weight: 600;
      display: block;
    }

    >div:nth-child(2) p {
      color: #fff;
      font-size: 6px;
    }


    >div:nth-child(3) span {
      margin-top: 20px;
      color: #444198;
      font-size: 10px;
      font-weight: 600;
      display: block;
    }

    >div:nth-child(3) p {
      color: #444198;
      font-size: 6px;
    }
  }




}

.centerPhone {
  margin-top: 60px;

  .centerPhone-t {
    text-align: center;

    span {
      color: #c69c6c;
      font-weight: 500;

    }

    p {
      font-size: 30px;
      color: #6968a1;
    }
  }

  .centerPhone-x {
    img {
      width: 100%;
    }
  }
}

.content {
  display: block;
  height: 300px;

  .content-what {
    margin: 20px auto;
    width: 400px;


    img {
      width: 400px;
    }
  }

  .content-cube {
    margin: auto;
    width: 200px;
    margin-bottom: 5px;

    img {
      width: 200px;
    }

  }

  .content-phase {
    width: 40px;
    margin: auto;

    span {

      text-align: center;
      width: 40px;
      display: inline-block;

      color: #fff;
      border: 1px solid black;
      border-radius: 10px;
      background-color: #363663;
    }
  }

  .content-dig {
    display: flex;
    justify-content: space-around;

    p {
      font-size: 10px;
      text-indent: 2em;
    }
  }

  .content-img {
    display: flex;
    justify-content: space-evenly;

    >div:nth-child(1) {
      img {
        width: 100px;
        display: block;
        margin-top: 15px;
      }

    }

    >div:nth-child(2) {
      margin: auto 0;

      img {
        width: 20px;
      }

    }

    >div:nth-child(3) {
      margin: auto 0;

      img {
        width: 100px;
      }

    }

    //  .webImg{
    //   width: 100px;

    //  }
    // >img:nth-child(1) {
    //   width: 100px;
    // }

    // >img:nth-child(2) {
    //   width: 100px;
    // }

    // >img:nth-child(3) {
    //   width: 100px;
    // }

    // >img:nth-child(4) {
    //   width: 100px;
    // }
  }
}

.content-phone {
  text-align: center;

  >img:nth-child(1) {
    width: 500px;

  }

  >img:nth-child(2) {
    width: 300px;

  }

  .content-phoneDig {
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    align-items: center;
  }

  .content-phoneHot {
    display: flex;
    justify-content: space-evenly;

    >div:nth-child(1) {
      img {
        width: 200px;
        display: block;
        margin-top: 15px;
      }

    }

    >div:nth-child(2) {
      margin: auto 0;

      img {
        width: 40px;
      }

    }

    >div:nth-child(3) {
      margin: auto 0;

      img {
        width: 200px;
      }

    }

  }

}

.footPhone {
  margin-top: 60px;
  width: 100%;

  >img:nth-child(1) {
    width: 100%;
    // background-size: 100%;
    background: url(../assets/phone25.png) center/100% no-repeat;
  }

  >img:nth-child(2) {
    width: 100%;

    background: url(../assets/phone26.png) center/100% no-repeat;
  }

  >img:nth-child(3) {
    width: 100%;

    background: url(../assets/phone28.png) center/100% no-repeat;
  }

  >img:nth-child(1):hover {

    content: url('../assets/phone32.png');
  }

  >img:nth-child(2):hover {

    content: url('../assets/phone33.png');
  }

  >img:nth-child(3):hover {

    content: url('../assets/phone34.png');
  }


}


.footPhoneP {
  height: 300px;
  margin-top: 60px;
  background-color: #F5F5F5;
  text-align: center;

  img {
    width: 250px;
  }

  p {
    font-size: 28px;
    color: #6968a1;
  }

}

.foot {
  display: block;
  display: flex;

  >div:nth-child(1) {
    margin: auto;

    >img:nth-child(1) {
      width: 150px;
      // opacity: 0.5;
      background: url(../assets/web32.png) no-repeat;
      margin: 0 20px;
      background-size: 100%;
    }

    >img:nth-child(2) {
      width: 150px;

      background: url(../assets/web33.png) no-repeat;
      background-size: 100%;

    }

    >img:nth-child(3) {
      width: 150px;

      background: url(../assets/web34.png) no-repeat;
      background-size: 100%;

      margin: 0 20px;
    }

    >img:nth-child(1):hover {

      content: url('../assets/web26.png');
    }

    >img:nth-child(2):hover {

      content: url('../assets/web27.png');
    }

    >img:nth-child(3):hover {

      content: url('../assets/web28.png');
    }

  }



}

.weet {
  background-color: #F5F5F5;
  display: block;
  margin-bottom: 30px;
  color: #444198;
  margin-top: 30px;
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .weet-l {
    img {
      width: 100px;
    }
  }

  .weet-r {
    font-size: 10px;

    >span:nth-child(1) {
      display: block;
      margin: 10px 0;
    }
  }
}

@media(max-width: 1200px) {

  .Home {
    display: none;

  }

  .center {
    display: none;

  }

  .content {
    display: none;
  }

  .foot {
    display: none;
  }

  .weet {
    display: none;
  }
}

@media(max-width: 1200px) {

  .HomePhone {
    display: block;
  }
}</style>
